// extracted by mini-css-extract-plugin
export default {"alertRow":"bKW3A1YOSpTzKPQjsROq"};